import React from 'react';
import { ECOSYSTEM_LOGOS } from '../../data/dgpt';
import { Reveal } from '../ui/Reveal';
type Logo = (typeof ECOSYSTEM_LOGOS)[number];
function LogoItem({
  logo,
  hidden
}: {
  logo: Logo;
  hidden?: boolean;
}) {
  return <li className="flex shrink-0 items-center justify-center px-8 sm:px-12" aria-hidden={hidden || undefined} data-id="element-210" data-mp="mcp5bglufoze">
      <span className="flex h-12 w-36 items-center justify-center overflow-hidden sm:w-40" data-id="element-211" data-mp="reef6sxbxwlw">
        <img src={logo.src} alt={hidden ? '' : logo.name} width={160} height={48} loading="lazy" decoding="async" style={{
        transform: `scale(${logo.scale})`
      }} className="h-full w-full object-contain opacity-55 mix-blend-multiply grayscale transition-[filter,opacity] duration-200 hover:opacity-100 hover:brightness-[0.35] hover:contrast-[3]" data-id="element-212" data-mp="wb4vnhd1qu7u" />
      </span>
    </li>;
}

/**
 * Single-row infinite logo marquee. Two identical tracks scroll by -50% for a
 * seamless loop; pauses on hover and stops under prefers-reduced-motion.
 */
export function LogoStrip() {
  return <section aria-labelledby="trusted-heading" className="border-b border-hairline-soft bg-ink" data-id="element-213" data-mp="1ej3lio2edohz">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-12 sm:px-6 lg:px-8 lg:py-14" data-id="element-214" data-mp="1agyp5hkkedrn">
        <Reveal data-id="element-215" data-mp="15i5fk08ef6wr">
          <h2 id="trusted-heading" className="text-center text-[11px] font-medium uppercase tracking-[0.2em] text-text-tertiary" data-id="element-216" data-mp="15ioy9j5vhzbu">
            Trusted Across the Venture Ecosystem
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.06} className="dgpt-marquee group relative -mt-4 overflow-hidden pb-12 lg:pb-14" data-id="element-217" data-mp="1y8xfn8sl4fpd">
        <ul className="dgpt-marquee-track flex w-max items-center group-hover:[animation-play-state:paused]" data-id="element-218" data-mp="1tdrjlh5gxknk">
          {ECOSYSTEM_LOGOS.map(logo => <LogoItem key={logo.name} logo={logo} data-id="element-219" data-mp="2lxgllho5wgea" />)}
          {ECOSYSTEM_LOGOS.map(logo => <LogoItem key={`${logo.name}-dup`} logo={logo} hidden data-id="element-220" data-mp="2h4x2642smr1k" />)}
        </ul>
      </Reveal>
    </section>;
}